import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

const IconZorroBulb = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <circle cx="15.5" cy="11.5" r="7.5" fill="#FFEFCC" />
        <path
          stroke="#1A1721"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4 16h1.333M16 4v1.333M26.667 16H28M7.467 7.467 8.4 8.4m16.133-.933L23.6 8.4M12 21.333a6.667 6.667 0 1 1 8 0 4.67 4.67 0 0 0-1.333 4 2.666 2.666 0 1 1-5.334 0 4.67 4.67 0 0 0-1.333-4m.933 1.334h6.134"
        />
      </svg>
    </Center>
  );
};

export { IconZorroBulb };
